import { Component, OnInit } from '@angular/core';
import { DestroyService } from '../../../../services/destroy/destroy.service';
import { SortOrder, SubscriptionFilter, SubscriptionModel, SubscriptionServiceProxy } from '../../../../../shared/service-proxies/event-service-proxy';
import { takeUntil } from 'rxjs';
import { DateFormatterPipe } from '../../../../pipes/date/date-formatter.pipe';
import { ToastrService } from '../../../../services/toastr/toastr.service';
import { ErrorService } from '../../../../services/error/error.service';

@Component({
    selector: 'app-expiring-account-card',
    templateUrl: './expiring-account-card.component.html',
    styleUrl: './expiring-account-card.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class ExpiringAccountCardComponent implements OnInit {
  private subscriptionFilter: SubscriptionFilter = new SubscriptionFilter();
  subscriptions: SubscriptionModel[] = [];
  dataMissing: boolean|string = false || '';

  isLoading: boolean = true;
  currentPage: number = 1;
  pageSize: number = 6;
  totalItems: number = 0; 

  constructor(private errorService: ErrorService, private toastService: ToastrService, private _subscription: SubscriptionServiceProxy, private destroyService: DestroyService, private dateFormatterPipe: DateFormatterPipe) { }

  ngOnInit(): void {
    this.getSubscriptions();
  }

  getSubscriptions() {
    this.subscriptionFilter.sortOrder = SortOrder.Asc;
    this.subscriptionFilter.page = this.currentPage;
    this.subscriptionFilter.perPage = this.pageSize
    this.subscriptionFilter.expiresFrom = new Date();
    this.subscriptionFilter.expiresTo = new Date(Date.now() + 21 * 24 * 60 * 60 * 1000);
    this._subscription.getSubscriptions(this.subscriptionFilter)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(subscriptions => {
        this.totalItems = subscriptions.total; 
        this.subscriptions = subscriptions.items;
        console.log(this.subscriptions);
        this.isLoading = false;
        this.dataMissing = this.subscriptions.length == 0;
      }, error => {
        console.error(error);
        this.isLoading = false;
        this.dataMissing = 'Не удалось получить список подписок. Попробуйте позже.';
        this.errorService.handleError(error, 'Не удалось получить список подписок. Попробуйте позже.');
    })
  }
  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.getSubscriptions();
  }
}
